import { APP } from 'core-uda/model/Resource'
import { RIGHTS } from 'core-uda/Rights'
import _upperFirst from 'lodash/upperFirst'

export const MERCATOR_Y = 20037508.342789244

export const ADD_UDA_TOKEN = (imageTile: any, src: string) => {
  imageTile.getImage().src = `${src}&${APP().getLastTokenParameter()}`
}

export function hasYamlRight(layerId: string): boolean {
  const yamWithCommment: string = RIGHTS(
    `map.layers.yaml${_upperFirst(layerId)}`,
    null,
  )
  if (!yamWithCommment) return false
  const yaml = yamWithCommment
    .split('\n')
    .filter((line) => !line.trim().startsWith('#'))
    .join('\n')
    .trim()
  return !!yaml
}
